const eventSuccessLogin = (eventCategory, userId, loginMethod) => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `success_${eventCategory}_by_${loginMethod}`,
      eventCategory: `${eventCategory === 'login' ? 'login' : 'registration'}`,
      eventAction: `successfully ${eventCategory}`,
      user_id: userId,
      userId: userId,
    });
  }
};
export default eventSuccessLogin;
